import React from 'react';
import './sccs/FormInfoSolicitudesDependientes.scss';

interface FormInfoSolicitudesDependientesData {
	FaltaModelo145?: boolean;
	FaltaDSA?: boolean;
}

interface FormInfoSolicitudesDependientesProps {
	data?: FormInfoSolicitudesDependientesData | null;
}

const FormInfoSolicitudesDependientes: React.FC<FormInfoSolicitudesDependientesProps> = ({ data }) => {
	const showModelo145 = Boolean(data?.FaltaModelo145);
	const showDSA = Boolean(data?.FaltaDSA);

	if (!showModelo145 && !showDSA) {
		return null;
	}

	return (
		<div className='form-info-solicitudes-dependientes'>
			<div className='form-info-solicitudes-dependientes__header'>
				<span className='e-icons e-file-new form-info-solicitudes-dependientes__icon' aria-hidden='true' />
				<p className='paragraph mb-0 form-info-solicitudes-dependientes__title'>
					Solicitud incompleta, pendiente de:
				</p>
			</div>

			<ul className='form-info-solicitudes-dependientes__list'>
				{showModelo145 && (
					<li className='form-info-solicitudes-dependientes__item'>
						- <strong>Modelo 145</strong>, disponible en el apartado MIS GESTIONES – Gestiones de la prestación activa. Para todos los regímenes de la Seguridad Social.
					</li>
				)}

				{showDSA && (
					<li className='form-info-solicitudes-dependientes__item'>
						- <strong>Declaración de Situación de Actividad</strong>, disponible en el apartado MIS GESTIONES – Gestiones de la prestación activa. Sólo para trabajadores del Régimen de Autónomos.
					</li>
				)}
			</ul>
		</div>
	);
};

export default FormInfoSolicitudesDependientes;
